import React, { Component } from 'react';

class Footer extends Component {
  render(){
    return (
      <footer className="border-t border-slate-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 text-center text-xs text-slate-400">
          Randevu Takip
        </div>
      </footer>
    );
  }
}

export default Footer
